module.exports = __webpack_public_path__ + "img/cuco-regular-full.a958f77f.svg";